// extracted by mini-css-extract-plugin
export var betEntryContainer = "BetEntry-module--betEntryContainer--72d39";